import GradientBorderRadius from "@/ui/gradient-border-radius";
import { IconComponent } from "@/ui/icon";

const CheckBtn = ({ onClick }: { onClick: () => void }) => {
  return (
    <button onClick={onClick}>
      <GradientBorderRadius
        gradient="none"
        radius="circle"
        hover="r-100"
        active={undefined}
        background="black"
        className="w-[1.375rem] h-[1.375rem] flex justify-center items-center"
      >
        <IconComponent
          name="check"
          className="w-[0.75rem] h-[0.75rem]"
          fill="white"
        />
      </GradientBorderRadius>
    </button>
  );
};

export default CheckBtn;
